import { Flex, LssProp, Toggle, ToggleScale } from '@lucidhq/lucidium';
import { Field } from '@lucidhq/lucidium/components/FormV2';
import { useFormikContext } from '@lucidhq/lucidium/components/FormV2';
import { ReactNode } from 'react';

interface FormFieldToggleProps {
  name: string;
  testId?: string;
  scale?: ToggleScale;
  isDisabled?: boolean;
  lss?: LssProp;
  label?: ReactNode;
  onCustomChange?: (value: boolean, applyChange: () => void) => void;
}

export const FormFieldToggle = ({
  name,
  testId,
  scale,
  isDisabled,
  lss,
  label,
  onCustomChange,
}: FormFieldToggleProps) => {
  const { setFieldValue } = useFormikContext();

  return (
    <Field
      groupLss={lss}
      name={name}
      render={(fieldProps) => (
        <Flex lss={{ flexDirection: 'row', gap: 20, alignItems: 'center' }}>
          <Toggle
            {...fieldProps}
            lss={{ pb: 0 }}
            disabled={isDisabled}
            data-testid={testId}
            scale={scale}
            onChange={(value) => {
              if (onCustomChange)
                onCustomChange(value, () => setFieldValue(name, value));
              else setFieldValue(name, value);
            }}
          />
          {label && label}
        </Flex>
      )}
    />
  );
};
